module.exports = __webpack_public_path__ + "static/media/4309.8d571f08.jpg";